module.exports = __webpack_public_path__ + "static/img/C.7fc0468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl/C.png
// module id = GAn0
// module chunks = 0